import { ref, watch, computed, onMounted } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ability from '@/libs/acl/ability'

export default function useSuppliersList() {

    
    //User toast
    const toast = useToast()

    const refSupplierListTable = ref(null)

    const tableColumns = [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'name', label:'名稱'},
        {key: 'address', label:'地址'},
        {key: 'contacts', label:'姓名'},
        {key: 'phone', label: '電話'},
        {key: 'email', label: '電郵'},
        {key: 'remark', label: '備註'},
        {key: 'is_active', label: '狀態'},
        {key: 'actions', label: '操作'},
    ]

    //Filter
    const statusFilter = ref(-1)

    const perPage = ref(10)
    const totalSuppliers = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)

    const dataMeta = computed(() => {
        const localItemsCount = refSupplierListTable.value ? refSupplierListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalSuppliers.value,
        }
    })

    const refetchData = () => {
        refSupplierListTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery, statusFilter], () => {
        refetchData()
    })

    const fetchSuppliers = (ctx, callback) => {
        store.dispatch('supplier/fetchSuppliers',{
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
            is_active: statusFilter.value
        })
        .then(response =>{
            const {suppliers, total} = response.data
            callback(suppliers)
            totalSuppliers.value = total
        
        })
        .catch((error) => {
            console.log(error)
            toast({
                component: ToastificationContent,
                props: {
                    title: 'Error fetching supplier list',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger'
                }
            })
        })
    }

    return {
        fetchSuppliers,
        tableColumns,
        perPage,
        currentPage,
        totalSuppliers,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refSupplierListTable,
        ability,
        refetchData,
        statusFilter,
    }

}